import Product from './Product';

export default class Order {
  constructor(data) {
    const isDefaultData = typeof data === 'undefined';

    this.id = isDefaultData ? 0 : data.id;
    this.shop_id = isDefaultData ? 0 : data.shop_id;
    this.track_number = isDefaultData ? '' : data.track_number;
    this.worker_comment = isDefaultData ? '' : data.worker_comment;
    this.client_comment = isDefaultData ? '' : data.client_comment;
    this.sent_date = isDefaultData ? '' : data.sent_date;
    this.created_at = isDefaultData ? '' : data.created_at;
    this.updated_at = isDefaultData ? '' : data.updated_at;
    this.user_id = isDefaultData ? '' : data.user_id;
    this.removable = isDefaultData ? false : data.removable;
    this.products = [];

    if (typeof data !== 'undefined' && typeof data.products !== 'undefined') {
      data.products.forEach((item) => this.products.push(new Product(item)));
    }
  }
}
